"use client";

import * as React from "react";

const KEY = "nav_style";

type StyleMode = "icons" | "text";

function applyMode(mode: StyleMode) {
  if (typeof document === "undefined") return;
  document.body.classList.toggle("nav-text-only", mode === "text");
}

export default function NavStyleToggle() {
  const [mode, setMode] = React.useState<StyleMode>("icons");

  React.useEffect(() => {
    try {
      const saved = localStorage.getItem(KEY);
      const next: StyleMode = saved === "text" ? "text" : "icons";
      setMode(next);
      applyMode(next);
    } catch {
      applyMode("icons");
    }
  }, []);

  function toggle() {
    const next: StyleMode = mode === "icons" ? "text" : "icons";
    setMode(next);
    applyMode(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Ignore storage failures; UI still toggles for current session.
    }
  }

  return (
    <button className="nav-style-toggle" type="button" onClick={toggle} title="Navigation: Icons/Text">
      {mode === "icons" ? "Icons" : "Text"}
    </button>
  );
}

